import React from "react";
import { Button } from "primereact/button";
import { Message } from "primereact/message";
import type { ThgFailureKind } from "../../../types/thgAnnualSummary";
import { COPY } from "../ThgAnnualSummary.consts";

interface ThgFailureStateProps {
  kind: ThgFailureKind;
  year: number;
  message?: string | null;
  onRetry?: () => void;
}

/**
 * Why a year shows no figures. Each cause has its own remedy, so each gets its own text: a missing rate
 * needs a config change and retrying cannot help, a network blip can be retried.
 */
const ThgFailureState: React.FC<ThgFailureStateProps> = ({ kind, year, message = null, onRetry }) => {
  if (kind === "FORBIDDEN") {
    return <Message severity="error" className="w-full justify-content-start" text={COPY.accessDenied} />;
  }
  if (kind === "RATE_NOT_CONFIGURED") {
    // The backend's message names an internal setting, so it is deliberately not shown.
    return <Message severity="warn" className="w-full justify-content-start" text={COPY.rateNotConfigured(year)} />;
  }
  if (kind === "BAD_YEAR") {
    return (
      <Message
        severity="error"
        className="w-full justify-content-start"
        text={[COPY.badYear(year), message].filter(Boolean).join(" ")}
      />
    );
  }
  return (
    <div className="flex flex-column md:flex-row md:align-items-center gap-3">
      <Message
        severity="error"
        className="flex-grow-1 justify-content-start"
        text={message || COPY.loadFailed(year)}
      />
      {onRetry && <Button label="Retry" icon="pi pi-refresh" outlined size="small" onClick={onRetry} />}
    </div>
  );
};

export default ThgFailureState;
